export default {"src":"/_next/static/media/badge-rightest.0b11b5df.svg","height":138,"width":138};